import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="company_news" />;

export const Route = createFileRoute("/en/news/$slug")({
  loader: ({ params }) => loadContentMeta("company_news", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/news/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

